import { createSlice } from '@reduxjs/toolkit'

export interface TenantSelectionStateInterface {
  open: boolean,
  isLoading: boolean
}

const initialState: TenantSelectionStateInterface = {
  open: false,
  isLoading: false
}

const tenantSelectionSlice = createSlice({
  name: 'selection',
  initialState,
  reducers: {
    openTenantSelection(state) {
      return { ...state, open: true }
    },
    closeTenantSelection(state) {
      return { ...state, open: false }
    },
    showLoader(state) {
      return { ...state, isLoading: true }
    },
    hideLoader(state) {
      return { ...state, isLoading: false }
    }
  },
})

export const {
  openTenantSelection,
  closeTenantSelection,
  showLoader,
  hideLoader
} = tenantSelectionSlice.actions
export default tenantSelectionSlice.reducer
